import moment from 'moment';
import { SelectedExperienceType } from '../types';

export const getExperienceDates = (
  selectedExperiences: SelectedExperienceType[],
  fromDate: moment.Moment
): string[] => {
  if (!selectedExperiences || selectedExperiences.length === 0) {
    return [];
  }

  const datesSet = new Set<string>();

  selectedExperiences.forEach((exp) => {
    const dayNumbers = exp.dayNumberRange ?? [exp.dayNumber || 0];

    dayNumbers.forEach((dayNumber) => {
      const date = moment(fromDate).add(dayNumber, 'days').format('YYYY-MM-DD');
      datesSet.add(date);
    });
  });

  return Array.from(datesSet);
};
